import { render, staticRenderFns } from "./return-config.vue?vue&type=template&id=5dc52973&scoped=true"
import script from "./return-config.vue?vue&type=script&lang=js"
export * from "./return-config.vue?vue&type=script&lang=js"
import style0 from "./return-config.vue?vue&type=style&index=0&id=5dc52973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc52973",
  null
  
)

export default component.exports